import React, { Fragment } from "react";
import { GenericOngoing } from "../../../components/generic/GenericOngoing";

const ActivityLogPage = () => {
  return (
    <Fragment>
      <GenericOngoing pageName={'Activity Log'} />
    </Fragment>
  );
};

export default ActivityLogPage;